module.exports = __webpack_public_path__ + "5015b96e9e2e9eac7bb810df85615f8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-hiking-s.png
// module id = 1883
// module chunks = 0